import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Scorecard from "@/pages/Scorecard";
import Ledger from "@/pages/Ledger";
import PlayerProfile from "@/pages/PlayerProfile";
import Rivalry from "@/pages/Rivalry";
import TeamRivalry from "@/pages/Rivalry";
import Prototypes from "@/pages/Prototypes";
import RazzyFaq from "@/pages/RazzyFaq";
import InvitePage from "@/pages/InvitePage";
import LiveScorecard from "@/pages/LiveScorecard";
import RoundSummary from "@/pages/RoundSummary";
import ColorPreview from "@/pages/ColorPreview";
import AuthPage from "@/pages/AuthPage";
import SsoCallbackPage from "@/pages/SsoCallbackPage";
import { PasskeyEnrollBanner } from "@/components/PasskeyEnrollBanner";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Scorecard} />
      <Route path="/ledger" component={Ledger} />
      <Route path="/rounds/:roundId/live" component={LiveScorecard} />
      <Route path="/rounds/:roundId/summary" component={RoundSummary} />
      <Route path="/invite/:token" component={InvitePage} />
      <Route path="/player/:personId" component={PlayerProfile} />
      <Route path="/rivalry/player/:personA/:personB" component={Rivalry} />
      <Route path="/rivalry/team/:teamKey" component={TeamRivalry} />
      <Route path="/rivalry/:mode/:teamA/:teamB" component={Rivalry} />
      <Route path="/razzy-faq" component={RazzyFaq} />
      <Route path="/prototypes" component={Prototypes} />
      <Route path="/color-preview" component={ColorPreview} />
      <Route path="/auth" component={AuthPage} />
      <Route path="/sso-callback" component={SsoCallbackPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
        <PasskeyEnrollBanner />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
